import {FormControl, FormGroup, Validators} from "@angular/forms";

export class AdminFormHelperService{
    UserForm = new FormGroup({
        username: new FormControl(null, [Validators.required]),
        firstname: new FormControl(null, [Validators.required]),
        lastname: new FormControl(null, [Validators.required]),
        title: new FormControl(null),
        emailAddress: new FormControl(null, [Validators.required,Validators.email]),
        phonenumber: new FormControl(null, [Validators.required]),
        createddate: new FormControl(null),
        lastlogindate: new FormControl(null),
        experationdate: new FormControl(null),
        role: new FormControl(null, [Validators.required])
    })

    addUserForm = new FormGroup({
        username: new FormControl(null, [Validators.required]),
        password: new FormControl(null),
        firstname: new FormControl(null, [Validators.required]),
        lastname: new FormControl(null, [Validators.required]),
        title: new FormControl(null),
        emailAddress: new FormControl(null, [Validators.required,Validators.email]),
        phonenumber: new FormControl(null, [Validators.required]),
        role: new FormControl(null, [Validators.required])
    })
}
